/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import {
    bool, object,
} from 'prop-types';
import { useLocation } from 'react-router';
import DesktopMobile from '../../../../../../helpers/DesktopMobile/DesktopMobile';
import { CrossMerch } from '../../../../CrossMerchContainer/CrossMerchContainer';

/**
 * ----------------ThreeColumn Layout XL & L-------------------
 * |                                                          |
 * |  |---contentLeft---| |------contentRightContainer------| |
 * |  |                 | |                                 | |
 * |  |  width: 32.5%   | |         width: 65%              | |
 * |  |                 | |                                 | |
 * |  |                 | | |contentMiddle | |contentRight| | |
 * |  |                 | | |              | |            | | |
 * |  |                 | | |  width: 48%  | | width: 48% | | |
 * |  |                 | | |              | |            | | |
 * |  |                 | | |              | |            | | |
 * |  |                 | | |              | |            | | |
 * |  |                 | | |              | |            | | |
 * |  |-----------------| | |--------------| |------------| | |
 * |                      |---------------------------------| |
 * ------------------------------------------------------------
 */

/**
 * ----------------ThreeColumn Layout M -----------------------
 * |                                                          |
 * |  |---contentLeft---| |------contentRightContainer------| |
 * |  |                 | |                                 | |
 * |  |  width: 39%     | |         width: 58%              | |
 * |  |                 | |                                 | |
 * |  |                 | | |--------contentMiddle--------| | |
 * |  |                 | | |                             | | |
 * |  |                 | | |        width: 100%          | | |
 * |  |                 | | |-----------------------------| | |
 * |  |                 | |                                 | |
 * |  |                 | | |--------contentRight --------| | |
 * |  |                 | | |                             | | |
 * |  |                 | | |        width: 100%          | | |
 * |  |                 | | |-----------------------------| | |
 * |  |-----------------| |---------------------------------| |
 * ------------------------------------------------------------
 */

/**
 * ----------------ThreeColumn Layout 600px--------------------
 * |                                                          |
 * |  |-------------------contentLeft-----------------------| |
 * |  |                                                     | |
 * |  |                  width: 100%                        | |
 * |  |-----------------------------------------------------| |
 * |                                                          |
 * |  |------------contentRightContainer--------------------| |
 * |  |                                                     | |
 * |  |                  width: 100%                        | |
 * |  | |--------------contentMiddle---------------------|  | |
 * |  | |                                                |  | |
 * |  | |                 width: 100%                    |  | |
 * |  | |------------------------------------------------|  | |
 * |  |                                                     | |
 * |  | |--------------contentRight----------------------|  | |
 * |  | |                                                |  | |
 * |  | |                 width: 100%                    |  | |
 * |  | |------------------------------------------------|  | |
 * |  |-----------------------------------------------------| |
 * ------------------------------------------------------------
 */

const useStyles = makeStyles((theme) => ({
    contentTop: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        margin: '0px auto',
        maxWidth: '1400px',
        color: theme.palette.black,
        '@media screen and (max-width: 1024px)': {
            flexDirection: 'column',
            width: '100%',
        },
        '@media screen and (max-width: 1380px) and (min-width:600px)': {
            padding: '0px 10px',
        },
    },

    contentLeft: {
        width: '51%',
        '@media screen and (max-width: 1024px)': {
            width: '100%',
        },
        '@media screen and (max-width: 600px)': {
            width: 'calc(100% - 32px)',
            margin: '0px 16px',
            padding: '16px',
            border: '1px solid #888888',
            borderRadius: '8px',
        },
    },
    contentLeftInnerContainer: {
        border: '1px solid #888888',
        borderRadius: '8px',
        display: 'flex',
        padding: '28px',

        '@media screen and (max-width: 600px)': {
            display: 'block',
        },
    },
    innerContainer: {
        display: 'flex',
        '@media screen and (max-width: 600px)': {
            flexDirection: 'column',
        },
    },

    contentRight: {
        width: '49%',
        paddingLeft: '20px',
        '@media screen and (max-width: 1024px)': {
            width: '100%',
            paddingLeft: '0px',
        },
        '@media screen and (max-width: 600px)': {
            '& [id="passport-banner-section"]': {
                margin: '12px auto 0px',
            },
            '& [data-component="addonV3"]': {
                paddingTop: '0px !important',
                border: 'none',
            },
        },

    },

    productImageContainer: {
        width: '44%',
        paddingRight: '20px',
        '@media screen and (max-width: 600px)': {
            width: '100%',
            padding: '0px 0px 24px',

        },
    },
    productTitleContainer: {
        width: '56%',
        '@media screen and (max-width: 600px)': {
            width: '100%',
        },
    },
    seeProductLink: {
        color: theme.palette.cms?.black || '#000000',
        marginBottom: '20px',
        display: 'block',
        '@media screen and (max-width: 600px)': {
            marginBottom: '16px',
        },
    },
    foodProductLink: {
        marginBottom: '16px',
    },
}));

// documentation: https://1800flowersinc.atlassian.net/wiki/spaces/RP/pages/288227337/PDP+Product+Details+Page
const ThreeColumnPlaRedesign = (props) => {
    const {
        components,
        product,
        selectedSku,
        isPlaPassportEnabled,
        isPassportAfterCta,
    } = props;
    const skuCount = product?.productSkus?.length || 0;
    const {
        ProductTitle,
        GraphqlProductSkus,
        PDPAddToCart,
        PromoMessageUI,
        PLAProductIcon,
        RecommendationsBuilder,
        PlaRedesignProductImage,
        ProductImageUI,
        PassportBannerUI,
        PmallSummary,
    } = components;

    const classes = useStyles();
    const { presentation_family: presentationFamily = '', featureFlags = {} } = useContext(CrossMerch);
    const isFood = presentationFamily === 'food';
    // uncomment when needed
    const location = useLocation();
    const seeProductLink = () => (
        <a href={`${location?.pathname}?selectSku=${selectedSku?.id?.split('-')?.pop()}`} className={`${classes.seeProductLink} ${isFood ? classes.foodProductLink : ''}`}>See product details</a>
    );

    let plaEnabled;
    if (typeof window !== 'undefined') {
        plaEnabled = window?.location?.href.includes('adtype=pla');
    }
    const desktopLayout = () => (
        <div
            className={classes.contentTop}
            data-testid="pdp-variant-threecolumn"
        >
            <div className={classes.contentLeft}>
                <div className={classes.contentLeftInnerContainer}>
                    <div className={classes.productImageContainer}>
                        {PlaRedesignProductImage()}
                    </div>
                    <div className={classes.productTitleContainer}>
                        {ProductTitle()}
                        {seeProductLink()}
                        {GraphqlProductSkus('', true, false)}
                        {isPlaPassportEnabled && !isPassportAfterCta && PassportBannerUI()}
                        {PmallSummary()}
                        {PDPAddToCart()}
                        {isPlaPassportEnabled && isPassportAfterCta && PassportBannerUI()}
                    </div>
                </div>
                {PromoMessageUI()}
            </div>
            <div className={classes.contentRight}>
                {isFood && !plaEnabled && GraphqlProductSkus('', false, true)}
                {PLAProductIcon(true)}
                {RecommendationsBuilder()}
            </div>
        </div>
    );
    const mobileLayout = () => (
        <>
            {PLAProductIcon()}
            <div
                className={classes.contentTop}
                data-testid="pdp-variant-PlaRedesignThreeColumn"
            >
                <div className={`${classes.contentLeft}`}>
                    <div className={classes.innerContainer}>
                        <div className={classes.productImageContainer}>
                            {PlaRedesignProductImage()}
                        </div>
                        <div className={classes.productTitleContainer}>
                            {ProductTitle()}
                            {seeProductLink()}
                            {GraphqlProductSkus('', true, false)}
                        </div>
                    </div>
                    {isPlaPassportEnabled && !isPassportAfterCta && PassportBannerUI()}
                    {PmallSummary()}
                    {PDPAddToCart()}
                    {isPlaPassportEnabled && isPassportAfterCta && PassportBannerUI()}

                </div>
                {isFood && !plaEnabled && GraphqlProductSkus('', false, true)}
                {PromoMessageUI()}
                {RecommendationsBuilder()}
            </div>
        </>
    );

    return (
        <DesktopMobile
            breakpoint={600}
            desktop={() => (
                desktopLayout()
            )}
            mobile={() => (
                mobileLayout()
            )}
        />
    );
};

ThreeColumnPlaRedesign.propTypes = {
    components: object.isRequired,
    product: object.isRequired,
    selectedSku: object.isRequired,
    isPlaPassportEnabled: bool,
    isPassportAfterCta: bool,
};
ThreeColumnPlaRedesign.defaultProps = {
    isPlaPassportEnabled: false,
    isPassportAfterCta: false,
};

export default ThreeColumnPlaRedesign;
